module.exports={author:"Golden",date:"08/26/2021",publishDate:"08/26/2021",highlighted:!1,tags:"",title:"Love Hurts When You're Getting Older,"};